import Echo from "laravel-echo";

export function webSocket() {
  try {
    window.Pusher = require("pusher-js");
    const token = localStorage.getItem("user-token");
    window.Echo = new Echo({
      authEndpoint: `${process.env.VUE_APP_URL}api/broadcasting/auth`,
      broadcaster: "pusher",
      key: process.env.VUE_APP_WEBSOCKET_KEY,
      cluster: process.env.VUE_APP_WEBSOCKET_CLUSTER,
      wsHost: process.env.VUE_APP_WEBSOCKET_URL,
      wsPort: process.env.VUE_APP_WEBSOCKET_PORT || "",
      forceTLS: false,
      disableStats: true,
      enabledTransports: ["ws", "wss"],
      auth: {
        headers: {
          Authorization: "Bearer " + token
        }
      }
    });
  } catch (e) {
    console.error(e);
  }
}
